﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import purify from 'dompurify';
import mathjax from 'mathjax/es5/tex-svg.js?url'

import { AppState } from './Store';
import * as Types from './Store/Types';
import { updateParagrafer, visMerknad } from './Store/Actions';
import { ModalCompontent } from '../Shared/Scripts/Components/ModalComponent';
import { ArticleContentComponent } from '../Shared/Scripts/Components/ArticleContentComponent';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';

interface AppOwnProps {
    tittel: string;
    kapittelFramtidigeEndringer: string;
    lukkLenketekst: string;
    lukkMerknadAriaLabel: string;
    contentLink: string;
    aktivVedStart: string;
}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

ReactModal.setAppElement(document.getElementById('regel-paragrafer') as HTMLElement);

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
        this.state = {
            readyToTypeset: false,
            mathjaxConfig: {
                startup: {
                    ready: () => {
                        window.MathJax.startup.defaultReady();
                        this.setState({ readyToTypeset: true });
                    }
                }
            }
        };
    }
    componentDidMount() {
        window.MathJax = this.state.mathjaxConfig;
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.defer = true;
        script.src = mathjax;
        document.head.appendChild(script);
    }
    componentDidUpdate() {
        if (this.state.readyToTypeset)
            window.MathJax.typesetPromise();

        if (this.props.paragraferState.firstLoadReady) {
            Array.from(document.getElementsByClassName('c-regel__paragraf-body')).forEach(x => {
                document.getElementById(x.id)!.classList.add('sr-only');
            });

            if (this.props.aktivVedStart !== '') {
                if (this.props.aktivVedStart === 'notfound') {
                    history.replaceState(null, '', window.location.href.split('?')[0]);
                } else {
                    let expandArea = document.getElementById('paragraf-' + this.props.aktivVedStart.toString());
                    expandArea?.classList.remove('sr-only');
                    let anchor = document.getElementById(this.props.aktivVedStart.toString());                   
                    anchor?.scrollIntoView();
                    history.replaceState(null, '', window.location.href.split('?')[0] + "#" + this.props.aktivVedStart.toString());
                }
            } else if (location.hash !== '') {
                let expandArea = document.getElementById('paragraf-' + location.hash.split('#')[1]);
                expandArea?.classList.remove('sr-only');
                let anchor = document.getElementById(location.hash.split('#')[1]);
                anchor?.scrollIntoView();
            }
        }
    }

    render(): JSX.Element {
        const {
            paragraferState,
            tittel,
            kapittelFramtidigeEndringer,
            lukkLenketekst,
            lukkMerknadAriaLabel,
            dispatchUpdate,
            dispatchMerknad,
        } = this.props;

        if (paragraferState.loading) {
            return (<div>Laster...</div>);
        }

        if (paragraferState.visFeilmelding) {
            return (<FeilmeldingComponent />);
        }

        
        function ParagrafHeader(props: any){
            const paragrafHeader: string = props.tittel;
            const className: string = props.cssClass;
           
            return (
                <div className={className} dangerouslySetInnerHTML={{ __html: purify.sanitize(paragrafHeader) }}>

                </div>
            );
        }
        return (
            <div id="paragrafer" className="c-regel__content">
                <div className="c-regel__tittel">
                    {tittel &&
                        <h2 className="c-regel__tittel-overskrift">{tittel}</h2>
                    }
                </div>
                <div
                  className="c-regel__tittel"
                  dangerouslySetInnerHTML={{ __html: purify.sanitize(kapittelFramtidigeEndringer, { FORBID_ATTR: ["class"] }) }}
                ></div>
                {paragraferState.kapittelMerknadTekst &&
                    <div className="c-regel__paragraf-modallenke">
                        <div className="c-regel__paragraf-modallenke-bakgrunn c-regel__kapittel-modallenke-bakgrunn">
                            <button className="c-knapp c-knapp--lenke" onClick=
                                {
                                    (): void => {
                                        dispatchMerknad("999")
                                    }
                                }>{paragraferState.kapittelMerknadLenketekst}</button>
                        </div>
                    </div>
                }
                {paragraferState.modalOpen === "999" &&
                    <ModalCompontent
                        isOpen={paragraferState.modalOpen === "999"}
                        onRequestClose={
                            (): void => {
                                dispatchMerknad(undefined)
                            }
                        }
                        ariaCloseText={lukkMerknadAriaLabel}
                    >
                        <ArticleContentComponent
                            headerinnhold={<span>{paragraferState.kapittelMerknadOverskrift}</span>}
                            contentinnhold={<div dangerouslySetInnerHTML={{ __html: purify.sanitize(paragraferState.kapittelMerknadTekst!) }} />}
                        />
                    </ModalCompontent>
                }
                <div className="c-regel__paragrafer">
                    {
                        paragraferState.paragrafer!.map((item) => {
                            return (
                                <div id={item.id} key={item.paragraf.paragrafNummer} className="c-regel__paragraf">
                                    <div>
                                        <div
                                            className={"c-regel__paragraf-body"}
                                            aria-expanded={item.active}
                                            id={"paragraf-" + item.id}
                                        >
                                            <div className={item.active ? "c-regel__paragraf-wrapper c-regel__paragraf-wrapper--active" : "c-regel__paragraf-wrapper"}>
                                                <div className="c-regel__paragraf-overskrift">
                                                    <ParagrafHeader tittel={item.paragraf.paragrafTittel} cssClass={"c-regel__paragraftittel"}/>                                                    
                                                </div>
                                                <div className="c-regel__paragraf-innhold">
                                                    {
                                                        item.paragraf.leddListe.map((ledd: any, i: any) => {
                                                            
                                                            return (
                                                                <div key={i} className="c-regel__ledd">
                                                                    <p className={"c-regel__leddtekst"} dangerouslySetInnerHTML={{ __html: purify.sanitize(ledd) }} />                                                                                                                                   
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    
                                                </div>
                                                {item.visMerknader && item.merknadLenketekst &&
                                                    <div className="c-regel__paragraf-modallenke">
                                                        <div className="c-regel__paragraf-modallenke-bakgrunn">
                                                            <button className="c-knapp c-knapp--lenke" onClick=
                                                                {
                                                                    (): void => {
                                                                        dispatchMerknad(item.id)
                                                                    }
                                                                }>{item.merknadLenketekst}</button>
                                                        </div>
                                                    </div>
                                                }
                                                {item.endretUrl &&
                                                    <div className="c-regel__endret-lenke-wrapper">
                                                        <div className="c-regel__endret-lenke-container">
                                                            <a href={item.endretUrl} className="c-knapp c-knapp--lenke c-knapp--artikkellenke c-knapp--icon-after c-knapp--pil-hoyre-aubergine c-regel__endret-lenke">
                                                                {item.endretLenketekst}
                                                            </a>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <button aria-controls={"paragraf-" + item.id} aria-expanded={item.active} className={item.active ? "c-regel__button c-regel__button--active" : "c-regel__button"} onClick=
                                            {
                                                (): void => {
                                                    dispatchUpdate(item.id)
                                                }
                                            }>
                                            {!item.active &&                                               
                                                    <ParagrafHeader tittel={item.paragraf.paragrafTittel} cssClass={"c-regel__button-innhold"}/>                                                                                                                                                 
                                            }
                                            {item.active &&
                                                <div className="c-regel__button-innhold c-regel__button-innhold-active">{lukkLenketekst} {item.paragraf.paragrafNummer}</div>
                                            }
                                        </button>
                                    </div>
                                    <div>
                                        {paragraferState.modalOpen === item.id &&
                                            <ModalCompontent
                                                isOpen={paragraferState.modalOpen === item.id}
                                                onRequestClose={
                                                    (): void => {
                                                        dispatchMerknad(undefined)
                                                    }
                                                }
                                                ariaCloseText={lukkMerknadAriaLabel}
                                            >
                                                <ArticleContentComponent
                                                    headerinnhold={<span>{item.merknadOverskrift}</span>}
                                                    contentinnhold={<div dangerouslySetInnerHTML={{ __html: purify.sanitize(item.merknad) }} />}
                                                />
                                            </ModalCompontent>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

interface MapStateToProps {
    paragraferState: Types.ParagraferState;
}

const mapStateToProps = (state: AppState): MapStateToProps => ({
    paragraferState: state.paragraferState,
});

interface MapDispatchToProps {
    dispatchUpdate: (aktivParagraf: string) => void;
    dispatchMerknad: (merknadlink: string | undefined) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<AppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdate: (clickedParagraf: string): void => {
        dispatch(updateParagrafer(clickedParagraf));
    },
    dispatchMerknad: (paragrafId: string | undefined): void => {
        dispatch(visMerknad(paragrafId));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
